<template>
  <div v-if="moisComptable">
    <div class="border-entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ getTitle }}
          </h1>
        </div>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">
            <button
              @click="$router.go(-1)"
              class="button btn-modal-annuler is-cancel">
              {{ $t('general.button.cancel') }}
            </button>
            <div
              @click="save()"
              class="button is-addOrEdit">
              <span> {{ $t('general.button.sauvegarder') }} </span>
            </div>
          </div>
        </div>
      </div>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </div>

    <error-msg-component
      :messages="messages"
      :error="error" class="mgt-20px"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      @close="error = $event"
      title="editionClient.problemOccurred"
      withEmplyFields/>

    <div class="corps">
      <component
        :is="activeTab"
        :detail="false"
        :mois-comptable="moisComptable"/>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { create, update, get } from '@/api/presse/moisComptable';
import breadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Information from '@/components/presse/moisComptable/information/information';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatDate from '@/services/general/formatIsoDate';
import validationGeneral from '@/services/validation/validation';
import genererMoisComptable from '@/services/presse/moisComptable/genererMoisComptable';
import translate from '@/services/presse/moisComptable/translator';
import validationMoisComptable from '@/services/presse/moisComptable/validationMoisComptable';

export default {
  name: 'm_moisComptable',
  data() {
    return {
      error: false,
      activeTab: 'information',
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      libelle: null,
      moisComptable: null,
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    Information,
  },
  computed: {
    breadcrumb() {
      let routeName = 'm.presse.mois_comptable-add';
      if (this.$route.params.id) routeName = 'm.presse.mois_comptable-edit';
      return [
        { title: this.$i18n.t('addEditMoisComptable.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addEditMoisComptable.breadcrumb.liste'), route: { name: 'l.presse.mois_comptable' }, isActive: false },
        { title: this.getTitle, route: { name: routeName }, isActive: true },
      ];
    },
    getTitle() {
      return this.$route.params.id
        ? this.$i18n.t('addEditMoisComptable.breadcrumb.edit', { libelle: this.libelle })
        : this.$i18n.t('addEditMoisComptable.breadcrumb.add');
    },
  },
  methods: {
    postGetMoisComptable(moisComptable) {
      if (moisComptable.dateDebut) moisComptable.dateDebut = new Date(moisComptable.dateDebut);
      if (moisComptable.dateFin) moisComptable.dateFin = new Date(moisComptable.dateFin);
      return moisComptable;
    },
    preSaveOrUpdateMoisComptable() {
      const moisComptable = cloneDeep(this.moisComptable);
      moisComptable.dateDebut = formatDate(moisComptable.dateDebut);
      moisComptable.dateFin = formatDate(moisComptable.dateFin);
      return moisComptable;
    },
    async save() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        let result = null;
        const moisComptable = this.preSaveOrUpdateMoisComptable();
        if (this.$route.params.id) {
          result = (await update(moisComptable)).data.result;
          messageSucces(this.$t('addEditMoisComptable.notifications.successChange'));
        } else {
          result = (await create(moisComptable)).data.result;
          messageSucces(this.$t('addEditMoisComptable.notifications.successCreation'));
        }
        await this.$router.push({
          name: 'c.presse.mois_comptable',
          params: { id: result.id },
        });
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          validationMoisComptable(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      let moisComptable = {};
      if (this.$route.params.id) {
        moisComptable = (await get(this.$route.params.id)).data.result;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: formatDate(moisComptable.dateDebut) + ' - ' + formatDate(moisComptable.dateFin) }));
      } else {
        this.setInformationPage(this.$t('pagePresse.moisComptable.creation'));
        moisComptable = genererMoisComptable();
      }
      this.moisComptable = this.postGetMoisComptable(moisComptable);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
